import BaseUtil from "../../../util/BaseUtil";
import UserTypeUtil from "../../../util/UserTypeUtil";

const type = `@@ActionType/UPDATE@${__filename}`;


const initState = {
    selectedUnitIds: [], // 选中的科室
    selectedUserTypes: UserTypeUtil.getAllUserTypeCodes(),
    unitsMap: null,
    chart: null, // 选中的表格
    selectedHospitalIds: ["ALL"],
    selectedDistrictIds: ["ALL"],
    loading: false,
    chartData: null, // 图表数据
    tableData: null, // 表格数据
    dataKeys: null, // 数据key值，用于计算column

    detailDrawerVisible: false, // 详情显隐
    detailDrawerData: null, // 详情数据
    detailDrawerLoading: false, // 详情加载
    clickedCell: {
        unitId: null, // 点击查看详情的科室
        option: null, // 点击查看详情的字典
        title: null, // 点击查看详情的标题
    },
    // 筛选
    filterData: null,
    filterDisplay: null,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
